import { Grid, TextField } from '@material-ui/core';
import React, { ChangeEvent } from 'react';
import { ForeignAddressFieldProps } from './ForeignAddressFieldProps';

export const ForeignAddressMiniForm = ({
  onChange = () => undefined,
  value: valueProp = {
    address1: '',
    address2: '',
    city: '',
    postalCode: '',
    region: '',
    country: '',
  },
  Address1Props = {
    name: 'address1',
    label: 'Address 1',
  },
  Address2Props = {
    name: 'address2',
    label: 'Address 2',
  },
  CityProps = {
    name: 'city',
    label: 'City',
  },
  PostalCodeProps = {
    name: 'postalCode',
    label: 'Postal Code',
  },
  RegionProps = {
    name: 'region',
    label: 'Region',
  },
  CountryProps = {
    name: 'country',
    label: 'Country',
  },
}: ForeignAddressFieldProps): JSX.Element => {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    onChange({ ...valueProp, [name]: value });
  };

  return (
    <Grid container>
      <Grid item xs={12}>
        <TextField
          fullWidth
          {...Address1Props}
          onChange={handleChange}
          value={valueProp?.address1}
          data-testid={'address-1'}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          {...Address2Props}
          onChange={handleChange}
          value={valueProp?.address2}
          data-testid={'address-2'}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField fullWidth {...CityProps} onChange={handleChange} value={valueProp?.city} data-testid={'city'} />
      </Grid>
      <Grid item xs={6}>
        <TextField
          fullWidth
          {...RegionProps}
          onChange={handleChange}
          value={valueProp?.region}
          data-testid={'region'}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          fullWidth
          {...PostalCodeProps}
          onChange={handleChange}
          value={valueProp?.postalCode}
          data-testid={'postal-code'}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          {...CountryProps}
          onChange={handleChange}
          value={valueProp?.country}
          data-testid={'country'}
        />
      </Grid>
    </Grid>
  );
};
